<template>
    <div class="lefttop_btn">
        <div class="lefttop_btn_img" @click="onItemClick('map')"><img src="../img/icon_layer.png" /></div>
        <ul class="lefttop_btn_word">
          <li  v-for="(item, index) in floors"
               :key="index"
               :class="currentIndex == index ? 'active' : ''"
               @click="onItemClick(item, index)">{{ item }}</li>
        </ul>
    </div>
</template>

<script>
import * as Cesium from 'cesium';

export default {
    name: "FloorControl",
    components: {},
    props:{
      floors:Array
    },
    data() {
        return {
          currentIndex:null
        };
    },
    mounted() {
    },
    methods: {
      onItemClick(item,index=null){
        this.currentIndex=index;
        window.viewer.scene._primitives._primitives.map((tileset)=>{
          if(tileset.type=="tileset"){
            if(tileset.id==item){
              tileset.show=true;
            }else if(tileset.id!="map"){
              tileset.show=false;
            }
          }

          if(tileset.id=="map"){
            if(item!='map'){
              //设置模型颜色，调透明
              tileset.style =new Cesium.Cesium3DTileStyle({
                color: "color('rgba(255,255,255,0.7)')",
              });
              tileset.clippingPlanes= new Cesium.ClippingPlaneCollection({
                planes : [
                 new Cesium.ClippingPlane(new Cesium.Cartesian3(0.0, 0.0, -0.1), 0.01)
                ],
                edgeWidth : 0.0
              });
            }else{
              tileset.style=null;
              tileset.clippingPlanes=new Cesium.ClippingPlaneCollection({
                planes : [],
                edgeWidth : 0.0
              });
            }
          }
        });
      }
    },
};
</script>

<style lang="less">
    ul,
    li,
    p {
        list-style-type: none;
        margin: 0;
        padding: 0;
    }
    .active {
      background: #4488bb;
    }
    .lefttop_btn{
        position: absolute;
        top: 85px;
        left: 412px;
        z-index: 990;
        .lefttop_btn_img{
            width: 42px;
            height: 42px;
            background: rgba(164, 218, 231, .6);
            border-radius: 2px;
            display: flex;
            align-items: center;
            justify-content: center;
            cursor: pointer;
            img {
                width: 35px;
                height: 35px;
            }
        }
        .lefttop_btn_img:active{
            background: #4488bb;
        }
        .lefttop_btn_word{
            margin-top: 1px;
            border-radius: 2px;
            background: rgba(164, 218, 231, .6);
            li {
                width: 42px;
                height: 42px;
                text-align: center;
                line-height: 42px;
                color: #000;
                cursor: pointer;

            }
            li+li{
                border-top: 1px solid #63a0df;
            }
        }
    }
</style>
